import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt-8 space-y-5" }
const _hoisted_4 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_5 = { class: "grid gap-3 lg:grid-cols-5" }
const _hoisted_6 = { class: "lg:col-span-3" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "lg:col-span-1" }
const _hoisted_9 = { class: "grid gap-4 sm:grid-cols-2 xl:grid-cols-4" }
const _hoisted_10 = { class: "text-sm font-semibold text-slate-500" }
const _hoisted_11 = { class: "mt-3 text-2xl font-bold text-slate-900" }
const _hoisted_12 = { class: "mt-1 text-xs text-slate-500" }
const _hoisted_13 = { class: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" }
const _hoisted_14 = { class: "overflow-x-auto" }
const _hoisted_15 = { class: "min-w-full text-sm" }
const _hoisted_16 = { class: "bg-blue-900" }
const _hoisted_17 = { class: "px-4 py-3.5 text-left" }
const _hoisted_18 = { class: "px-4 py-3.5 text-left" }
const _hoisted_19 = { class: "px-4 py-3.5 text-left" }
const _hoisted_20 = { class: "px-4 py-3.5 text-left" }
const _hoisted_21 = { class: "px-4 py-3.5 text-left" }
const _hoisted_22 = { class: "bg-white divide-y divide-slate-100" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "px-4 py-3 align-middle" }
const _hoisted_26 = ["src", "onClick"]
const _hoisted_27 = {
  key: 1,
  class: "flex items-center justify-center w-10 h-10 text-xs text-slate-400 bg-slate-100 border border-slate-200 rounded-lg"
}
const _hoisted_28 = { class: "px-4 py-3 align-middle" }
const _hoisted_29 = { class: "font-semibold text-slate-900 whitespace-nowrap" }
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "px-4 py-3 align-middle" }
const _hoisted_32 = { class: "text-slate-700 whitespace-nowrap" }
const _hoisted_33 = { class: "px-4 py-3 text-slate-600 align-middle whitespace-nowrap" }
const _hoisted_34 = { class: "px-4 py-3 align-middle whitespace-nowrap" }
const _hoisted_35 = { class: "text-slate-900" }
const _hoisted_36 = { class: "text-xs text-slate-500" }
const _hoisted_37 = { class: "px-4 py-3 align-middle" }
const _hoisted_38 = { class: "px-4 py-3 text-right align-middle whitespace-nowrap" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]

import { ref, computed, onMounted } from 'vue';
import {
  GET_KEGIATAN_KEMITRAAN,
  DELETE_KEGIATAN_KEMITRAAN,
} from '@/store/kegiatanKemitraan.module';
import ModalForm from '../components/modal/FormKegiatanKemitraan.vue';
import { useStore } from 'vuex';
import Breadcrumb from '../components/AppBreadcrumb.vue';
import { confirmDelete, errorAlert, successAlert } from '@/utils/swal';
import AppSelect from '@/components/input/AppSelect.vue';
import type { EntityId, KegiatanKemitraan } from '@/types/domain';
import SortButton from '@/components/table/SortButton.vue';

type SortDirection = 'asc' | 'desc';
type KegiatanSortKey = 'name' | 'kemitraanName' | 'location' | 'startDate' | 'status';
type SortRule = {
  key: KegiatanSortKey;
  direction: SortDirection;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'KegiatanKemitraanView',
  setup(__props) {

const store = useStore();

const isOpened = ref(false);
const dataUpdate = ref<Partial<KegiatanKemitraan>>({});
const currentId = ref<EntityId | undefined>(undefined);
const isImageModalOpen = ref(false);
const selectedImage = ref('');
const searchQuery = ref('');
const statusFilter = ref('');
const isLoading = ref(true);
const sortRules = ref<SortRule[]>([{ key: 'startDate', direction: 'desc' }]);
const statusFilterOptions = [
  { value: '', label: 'Semua' },
  { value: 'planned', label: 'Direncanakan' },
  { value: 'ongoing', label: 'Berlangsung' },
  { value: 'completed', label: 'Selesai' },
  { value: 'cancelled', label: 'Dibatalkan' },
];

const openModal = () => {
  dataUpdate.value = {};
  currentId.value = undefined;
  isOpened.value = true;
};

const handleModalClose = async () => {
  isOpened.value = false;
  dataUpdate.value = {};
  currentId.value = undefined;
  await getData();
};

const computedData = computed<KegiatanKemitraan[]>(() => {
  const list = store.getters.kegiatanKemitraan;
  return Array.isArray(list) ? list : list?.data || [];
});

const filteredData = computed(() => {
  const items = computedData.value.filter((k) => !statusFilter.value || k?.status === statusFilter.value);
  return [...items].sort((a, b) => compareKegiatan(a, b, sortRules.value));
});

const kpiCards = computed(() => {
  const items = filteredData.value;
  const planned = items.filter((item) => item?.status === 'planned').length;
  const ongoing = items.filter((item) => item?.status === 'ongoing').length;
  const completed = items.filter((item) => item?.status === 'completed').length;

  return [
    {
      title: 'Total Kegiatan',
      value: String(items.length),
      description: 'Kegiatan yang tampil pada daftar',
    },
    {
      title: 'Direncanakan',
      value: String(planned),
      description: 'Kegiatan yang masih dalam rencana',
    },
    {
      title: 'Berjalan',
      value: String(ongoing),
      description: 'Kegiatan yang sedang berlangsung',
    },
    {
      title: 'Selesai',
      value: String(completed),
      description: 'Kegiatan yang sudah selesai',
    },
  ];
});

const getData = async () => {
  isLoading.value = true;
  try {
    await store.dispatch(GET_KEGIATAN_KEMITRAAN, {
      data: { limit: 100, search: searchQuery.value || undefined },
    });
  } finally {
    isLoading.value = false;
  }
};

let searchTimer: ReturnType<typeof setTimeout> | null = null;
const onSearch = () => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(getData, 350);
};

const normalizeText = (value: unknown) => String(value ?? '').toLowerCase();

const normalizeDate = (value: unknown) => {
  if (!value) return 0;
  const timestamp = new Date(String(value)).getTime();
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

const compareValue = (left: string | number, right: string | number) => {
  if (typeof left === 'number' && typeof right === 'number') return left - right;
  return String(left).localeCompare(String(right), 'id', { numeric: true, sensitivity: 'base' });
};

const compareKegiatan = (
  left: KegiatanKemitraan,
  right: KegiatanKemitraan,
  rules: SortRule[],
) => {
  const getValue = (item: KegiatanKemitraan, key: KegiatanSortKey) => {
    if (key === 'startDate') return normalizeDate(item?.startDate);
    if (key === 'kemitraanName') return normalizeText(item?.kemitraan?.name);
    return normalizeText(item?.[key]);
  };

  for (const rule of rules) {
    const result = compareValue(getValue(left, rule.key), getValue(right, rule.key));
    if (result !== 0) {
      return result * (rule.direction === 'asc' ? 1 : -1);
    }
  }

  return 0;
};

const defaultSortDirection = (key: KegiatanSortKey): SortDirection =>
  key === 'startDate' ? 'desc' : 'asc';

const sortPriority = (key: KegiatanSortKey) => {
  const index = sortRules.value.findIndex((rule) => rule.key === key);
  return index === -1 ? 0 : index + 1;
};

const sortDirectionFor = (key: KegiatanSortKey): SortDirection => {
  return sortRules.value.find((rule) => rule.key === key)?.direction || defaultSortDirection(key);
};

const toggleSort = (key: KegiatanSortKey, event?: MouseEvent) => {
  const currentRule = sortRules.value.find((rule) => rule.key === key);
  const nextRule: SortRule = {
    key,
    direction: currentRule?.direction === 'asc' ? 'desc' : 'asc',
  };

  if (event?.shiftKey) {
    sortRules.value = currentRule
      ? sortRules.value.map((rule) => (rule.key === key ? nextRule : rule))
      : [...sortRules.value, { key, direction: defaultSortDirection(key) }];
    return;
  }

  sortRules.value = currentRule ? [nextRule] : [{ key, direction: defaultSortDirection(key) }];
};

onMounted(getData);

const openImageModal = (imageUrl: string) => {
  selectedImage.value = imageUrl;
  isImageModalOpen.value = true;
};
const closeImageModal = () => {
  isImageModalOpen.value = false;
};

const formatDate = (dateString?: string) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];
  return `${String(date.getDate()).padStart(2, '0')} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
};

const statusLabels: Record<string, string> = {
  planned: 'Direncanakan',
  ongoing: 'Berlangsung',
  completed: 'Selesai',
  cancelled: 'Dibatalkan',
};

const statusLabel = (status?: string) => {
  if (!status) return '—';
  return statusLabels[status.toLowerCase()] || status;
};

const statusClass = (status?: string) => {
  switch ((status || '').toLowerCase()) {
    case 'ongoing':
      return 'bg-blue-100 text-blue-700';
    case 'completed':
      return 'bg-green-100 text-green-700';
    case 'planned':
      return 'bg-yellow-100 text-yellow-700';
    case 'cancelled':
      return 'bg-red-100 text-red-700';
    default:
      return 'bg-slate-100 text-slate-600';
  }
};

const editItem = (item: KegiatanKemitraan) => {
  dataUpdate.value = { ...item };
  currentId.value = item.id;
  isOpened.value = true;
};

const deleteItem = async (id: EntityId) => {
  const result = await confirmDelete();
  if (!result.isConfirmed) return;
  try {
    await store.dispatch(DELETE_KEGIATAN_KEMITRAAN, { id });
    await successAlert('Kegiatan telah dihapus.');
    await getData();
  } catch (err) {
    await errorAlert(err instanceof Error ? err.message : 'Gagal menghapus kegiatan.');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: "kegiatan-kemitraan" }),
    (isOpened.value)
      ? (_openBlock(), _createBlock(ModalForm, {
          key: 0,
          id: currentId.value,
          title: `${currentId.value ? 'Edit' : 'Tambah'} Kegiatan Kemitraan`,
          data: dataUpdate.value,
          onClose: handleModalClose
        }, null, 8, ["id", "title", "data"]))
      : _createCommentVNode("", true),
    (isImageModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/60",
          onClick: closeImageModal
        }, [
          _createElementVNode("img", {
            src: selectedImage.value,
            alt: "Gambar",
            class: "max-w-full max-h-full rounded-md shadow-lg"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
        _createElementVNode("div", { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }, [
          _cache[8] || (_cache[8] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-2xl font-bold md:text-4xl" }, "Kegiatan Kemitraan"),
            _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, "Daftar kegiatan yang terhubung dengan mitra institusi.")
          ], -1)),
          _createElementVNode("button", {
            class: "inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#003793] shadow-lg transition-all hover:-translate-y-px hover:shadow-xl sm:w-auto",
            onClick: openModal
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              class: "h-4 w-4"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
                "clip-rule": "evenodd"
              })
            ], -1),
            _createTextVNode(" Tambah Kegiatan ", -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Cari", -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "absolute inset-y-0 left-0 flex items-center pl-2.5" }, [
                _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  class: "w-4 h-4 text-slate-400 fill-current"
                }, [
                  _createElementVNode("path", { d: "M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z" })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                onInput: onSearch,
                placeholder: "Cari nama kegiatan...",
                class: "block w-full rounded-lg border border-slate-200 bg-white py-2 pl-8 pr-3 text-sm text-slate-700 placeholder-slate-400 transition-all focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
              }, null, 544), [
                [_vModelText, searchQuery.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Status", -1)),
            _createVNode(AppSelect, {
              modelValue: statusFilter.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((statusFilter).value = $event)),
              options: statusFilterOptions
            }, null, 8, ["modelValue"])
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "rounded-xl bg-slate-50 px-4 py-3 lg:col-span-1" }, [
            _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Jadwal"),
            _createElementVNode("p", { class: "mt-1 text-sm text-slate-600" }, "Pantau lokasi, periode, dan status kegiatan.")
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiCards.value, (card) => {
          return (_openBlock(), _createElementBlock("div", {
            key: card.title,
            class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
          }, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(card.title), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(card.value), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(card.description), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex flex-col gap-3 border-b border-slate-100 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5" }, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Daftar Kegiatan"),
            _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Kegiatan kemitraan, lokasi, periode, dan status pelaksanaan.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("table", _hoisted_15, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_16, [
                _cache[15] || (_cache[15] = _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Gambar", -1)),
                _createElementVNode("th", _hoisted_17, [
                  _createVNode(SortButton, {
                    label: "Kegiatan",
                    active: sortPriority('name') > 0,
                    direction: sortDirectionFor('name'),
                    priority: sortPriority('name'),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSort('name', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _createElementVNode("th", _hoisted_18, [
                  _createVNode(SortButton, {
                    label: "Mitra",
                    active: sortPriority('kemitraanName') > 0,
                    direction: sortDirectionFor('kemitraanName'),
                    priority: sortPriority('kemitraanName'),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleSort('kemitraanName', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _createElementVNode("th", _hoisted_19, [
                  _createVNode(SortButton, {
                    label: "Lokasi",
                    active: sortPriority('location') > 0,
                    direction: sortDirectionFor('location'),
                    priority: sortPriority('location'),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSort('location', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _createElementVNode("th", _hoisted_20, [
                  _createVNode(SortButton, {
                    label: "Periode",
                    active: sortPriority('startDate') > 0,
                    direction: sortDirectionFor('startDate'),
                    priority: sortPriority('startDate'),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleSort('startDate', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _createElementVNode("th", _hoisted_21, [
                  _createVNode(SortButton, {
                    label: "Status",
                    active: sortPriority('status') > 0,
                    direction: sortDirectionFor('status'),
                    priority: sortPriority('status'),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleSort('status', $event)))
                  }, null, 8, ["active", "direction", "priority"])
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-right text-blue-100" }, "Aksi", -1))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_22, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (c) => {
                      return _createElementVNode("td", {
                        key: c,
                        class: "px-4 py-3"
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("div", { class: "h-4 w-full max-w-[120px] animate-pulse rounded bg-slate-100" }, null, -1)
                      ]))])
                    }), 64))
                  ]))
                : (filteredData.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("td", {
                        colspan: "7",
                        class: "px-5 py-12 text-sm text-center text-slate-400 italic"
                      }, "Belum ada kegiatan.", -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filteredData.value, (k, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: k.id || index,
                        class: "transition-colors hover:bg-blue-50/40"
                      }, [
                        _createElementVNode("td", _hoisted_25, [
                          (k?.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: k.image,
                                alt: "gambar",
                                class: "w-10 h-10 object-cover rounded-lg border border-slate-200 cursor-pointer shadow-sm hover:opacity-80",
                                onClick: ($event: any) => (openImageModal(k.image))
                              }, null, 8, _hoisted_26))
                            : (_openBlock(), _createElementBlock("div", _hoisted_27, " — "))
                        ]),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("p", _hoisted_29, _toDisplayString(k?.name || '-'), 1),
                          (k?.description)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: "max-w-xs mt-0.5 text-xs text-slate-500 truncate",
                                title: k.description
                              }, _toDisplayString(k.description), 9, _hoisted_30))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(k?.kemitraan?.name || '-'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(k?.location || '-'), 1),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("p", _hoisted_35, _toDisplayString(formatDate(k?.startDate)), 1),
                          _createElementVNode("p", _hoisted_36, "s/d " + _toDisplayString(formatDate(k?.endDate)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_37, [
                          _createElementVNode("span", {
                            class: _normalizeClass([statusClass(k?.status), "inline-block px-2 py-0.5 text-xs font-medium rounded-full"])
                          }, _toDisplayString(statusLabel(k?.status)), 3)
                        ]),
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("button", {
                            class: "mr-2 rounded-lg bg-blue-50 px-2.5 py-1.5 text-sm font-semibold text-blue-700 hover:bg-blue-100",
                            onClick: ($event: any) => (editItem(k))
                          }, "Edit", 8, _hoisted_39),
                          _createElementVNode("button", {
                            class: "rounded-lg bg-red-50 px-2.5 py-1.5 text-xs font-semibold text-red-600 hover:bg-red-100",
                            onClick: ($event: any) => (deleteItem(k.id))
                          }, "Hapus", 8, _hoisted_40)
                        ])
                      ]))
                    }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})